import Icon from '../components/Icon.vue'

Icon.register({
  weight: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 64H422C438.4 92.3 448 125 448 160 448 265.9 361.9 352 256 352S64 265.9 64 160C64 125 73.6 92.3 90 64H64C28.7 64 0 92.7 0 128V448C0 483.3 28.7 512 64 512H448C483.3 512 512 483.3 512 448V128C512 92.7 483.3 64 448 64zM256 320C344.4 320 416 248.4 416 160S344.4 0 256 0 96 71.6 96 160 167.6 320 256 320zM255.7 168.1L289.3 89.7C292.8 81.5 302.2 77.8 310.3 81.3 318.4 84.8 322.2 94.2 318.7 102.3L285.1 180.8C291.7 188 296 197.4 296 208 296 230.1 278.1 248 256 248S216 230.1 216 208C216 186 233.8 168.2 255.7 168.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/weight.js
// module id = J2cZ
// module chunks = 144